// extracted by mini-css-extract-plugin
export const title = "text-module--title--3i8qG";
export const content = "text-module--content--4dqC1";
export const products = "text-module--products--1oIBa";